/*
 * The mockup's own detail at the top of its page: the name, the dates and the tags. Every row
 * wraps, so the whole block fits a 320 px phone without a sideways scroll; a long name breaks
 * anywhere instead of widening the page.
 */
.detail {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.name {
  margin: 0;
  min-width: 0;
  font-size: 1.25rem;
  overflow-wrap: anywhere;
}

.form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem;
  min-width: 0;
}

.form > :first-child {
  flex: 1 1 12rem;
  min-width: 0;
}

.dates {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1rem;
  margin: 0;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.date {
  display: flex;
  gap: 0.375rem;
}

.date dd {
  margin: 0;
}
